/* Cambio elettronico: numeri cliccabili SULLE FOTO del kit dentro l'inserzione.

   I numerini non stanno in un blocco a parte: li infiliamo dentro le foto
   della galleria del prodotto, cosi si vedono gia sulla prima immagine che
   si apre. Li mettiamo su tutte le foto del kit (una per colore), cosi i
   numeri ci sono qualunque colore sia selezionato.

   Quali foto: si scelgono per pezzo di nome file, nel campo della sezione
   "Foto su cui mettere i numeri". Se il campo e vuoto li mette sulla prima.

   Clicchi il numerino e la spiegazione esce li accanto, SOPRA la foto.
   La bollicina prova ad andare a destra del numero, se non ci sta va a
   sinistra, se non ci sta nemmeno li va sotto il numero: in ogni caso
   resta dentro il bordo della foto, cosi non si taglia mai. */
(function () {
  function bersagli(radice) {
    var elenco = (radice.getAttribute('data-cp-foto') || '').split(',');
    var nomi = [];
    for (var n = 0; n < elenco.length; n++) {
      var v = elenco[n].replace(/^\s+|\s+$/g, '');
      if (v) nomi.push(v);
    }
    var out = [];
    var voci = document.querySelectorAll('.product__media-item');
    for (var i = 0; i < voci.length; i++) {
      var img = voci[i].querySelector('img');
      if (!img) continue;
      var src = img.getAttribute('src') || img.currentSrc || '';
      var ok = nomi.length === 0;
      for (var j = 0; j < nomi.length; j++) if (src.indexOf(nomi[j]) !== -1) ok = true;
      if (!ok) continue;
      var m = voci[i].querySelector('.product__media') || voci[i].querySelector('.media');
      if (m) out.push(m);
      if (!nomi.length) break;
    }
    return out;
  }

  /* Dawn taglia quello che esce dal riquadro della foto: apriamo il taglio
     sulla foto e su un paio di contenitori sopra, ma non sullo slider. */
  function apriTaglio(m) {
    var a = m;
    for (var lv = 0; lv < 4 && a; lv++) {
      if (a.classList && (a.classList.contains('product__media-list') ||
                          a.classList.contains('slider'))) break;
      if (a.tagName && a.tagName.toLowerCase() === 'media-gallery') break;
      a.style.overflow = 'visible';
      a = a.parentElement;
    }
  }

  function sposta(radice) {
    var pezzi = radice.querySelectorAll('.cp-pezzo');
    if (!pezzi.length) return false;
    var dove = bersagli(radice);
    if (!dove.length) {
      var f = radice.querySelector('[data-cp-fallback]');
      if (f) f.hidden = false;
      var n0 = radice.querySelector('.cp-aiuto');
      if (n0) n0.hidden = false;
      return false;
    }
    for (var d = 0; d < dove.length; d++) {
      dove[d].style.position = 'relative';
      apriTaglio(dove[d]);
      for (var i = 0; i < pezzi.length; i++) {
        dove[d].appendChild(d === dove.length - 1 ? pezzi[i] : pezzi[i].cloneNode(true));
      }
    }
    var nota = radice.querySelector('.cp-aiuto');
    if (nota) {
      var lista = dove[0].closest('media-gallery') || dove[0].closest('.product__media-list');
      if (lista && lista.parentNode) lista.parentNode.insertBefore(nota, lista.nextSibling);
      else dove[0].parentNode.appendChild(nota);
      nota.hidden = false;
    }
    radice.style.display = 'none';
    return true;
  }

  /* Mette la bollicina accanto al numero e la tiene dentro la foto. */
  function sistema(bolla) {
    var pezzo = bolla.parentNode;
    if (!pezzo) return;
    var foto = bolla.closest('.product__media') || bolla.closest('.media') || bolla.closest('.cp-foto');
    if (!foto) return;

    bolla.style.left = '0px';
    bolla.style.right = 'auto';
    bolla.style.top = '0px';

    var mf = foto.getBoundingClientRect();
    if (!mf.width) return;
    var largo = Math.min(240, Math.max(140, mf.width - 24));
    bolla.style.width = largo + 'px';

    var mp = pezzo.getBoundingClientRect();
    var mb = bolla.getBoundingClientRect();
    var bw = mb.width, bh = mb.height;
    var offX = mp.left - mf.left, offY = mp.top - mf.top;
    var maxX = mf.width - bw - 6, maxY = mf.height - bh - 6;

    var x, y = offY - 18;
    if (offX + 22 <= maxX) {
      x = offX + 22;                    // a destra del numero
    } else if (offX - bw - 8 >= 6) {
      x = offX - bw - 8;                // a sinistra del numero
    } else {
      x = offX + 13 - bw / 2;           // sotto il numero, centrata
      y = offY + 22;
    }
    if (x > maxX) x = maxX;
    if (x < 6) x = 6;
    if (y > maxY) y = maxY;
    if (y < 6) y = 6;

    bolla.style.left = (x - offX) + 'px';
    bolla.style.top = (y - offY) + 'px';
  }

  function avvia(radice) {
    if (radice.dataset.pronto) return;
    radice.dataset.pronto = '1';

    if (radice.hasAttribute('data-cp-dentro-foto')) sposta(radice);
    else {
      var f = radice.querySelector('[data-cp-fallback]');
      if (f) f.hidden = false;
      var n = radice.querySelector('.cp-aiuto');
      if (n) n.hidden = false;
    }

    var punti = document.querySelectorAll('[data-cp-punto]');
    var bolle = document.querySelectorAll('[data-cp-bolla]');
    if (!punti.length) return;

    function chiudi() {
      for (var i = 0; i < punti.length; i++) {
        punti[i].classList.remove('attivo');
        punti[i].setAttribute('aria-expanded', 'false');
      }
      for (var j = 0; j < bolle.length; j++) bolle[j].hidden = true;
    }

    function apri(chiave) {
      for (var i = 0; i < punti.length; i++) {
        var suo = punti[i].getAttribute('data-cp-punto') === chiave;
        punti[i].classList.toggle('attivo', suo);
        punti[i].setAttribute('aria-expanded', suo ? 'true' : 'false');
      }
      for (var j = 0; j < bolle.length; j++) {
        var mia = bolle[j].getAttribute('data-cp-bolla') === chiave;
        bolle[j].hidden = !mia;
        if (mia) sistema(bolle[j]);
      }
    }

    for (var k = 0; k < punti.length; k++) {
      (function (p) {
        p.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (p.classList.contains('attivo')) chiudi();
          else apri(p.getAttribute('data-cp-punto'));
        });
      })(punti[k]);
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cp-punto]') && !e.target.closest('[data-cp-bolla]')) chiudi();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') chiudi(); });
    window.addEventListener('resize', function () {
      for (var j = 0; j < bolle.length; j++) if (!bolle[j].hidden) sistema(bolle[j]);
    });

    chiudi();
  }

  function tutte() {
    var lista = document.querySelectorAll('[data-cp-radice]');
    for (var i = 0; i < lista.length; i++) avvia(lista[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
  else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
